import jwtAuthAxios from "./auth/jwtAuth";

const deliveryServices = {};

deliveryServices.getDeliveryDetails = async (delivery_id) => {
    const {data} = await jwtAuthAxios.get(`/deliveries/${delivery_id}/details`);
    return data;
};

deliveryServices.getDeliveryDocumentsSummary = async (delivery_id) => {
    try {
        const {data} = await jwtAuthAxios.get(`/deliveries/${delivery_id}/documents_summary`);
        return data;
    } catch (error) {
        return {
            error: error?.response?.data?.message || error.message,
            delivery_id_sent: delivery_id,
        };
    }
};

deliveryServices.getDeliveryRegularization = async (delivery_id) => {
    try {
        const {data} = await jwtAuthAxios.get(`/deliveries/${delivery_id}/documents_regularization`);
        return data;
    } catch (error) {
        return {
            error: error?.response?.data?.message || error.message,
            delivery_id_sent: delivery_id,
        };
    }
};

deliveryServices.getDeliveryDocumentsData = async (delivery_id) => {
    try {
        const {data} = await jwtAuthAxios.get(`/deliveries/${delivery_id}/documents_data`);
        return data;
    } catch (error) {
        return {
            error: error?.response?.data?.message || error.message,
            delivery_id_sent: delivery_id,
        };
    }
};

deliveryServices.destroyShippingDoc = async (shippingDocId) => {
    const { data } = await jwtAuthAxios.delete(`/shipping_docs/${shippingDocId}`);
    return data;
};

deliveryServices.getDeliveriesDocumentsTableHeaders = async () => {
    const {data} = await jwtAuthAxios.get('/deliveries/documents_table_headers');
    return data;
}

deliveryServices.getDeliveriesDocumentsTableData = async (params = {}) => {
    const { data } = await jwtAuthAxios.get('/deliveries/documents_table', { params });
    return data;
};  

deliveryServices.getDocsImages = async (delivery_id) => {
    const {data} = await jwtAuthAxios.get(`/deliveries/${delivery_id}/docs_images`);
    return data;
};

deliveryServices.updateDelivery = async (delivery_id, params) => {
    const {data} = await jwtAuthAxios.put(`/deliveries/${delivery_id}`, params);
    return data;
};

deliveryServices.updateDeliveryDetails = async (delivery_id, params) => {
    const { data } = await jwtAuthAxios.post(`/deliveries/${ delivery_id }/details_front`, params);
    return data;
};

deliveryServices.updateRegularization = async (delivery_id, params) => {
    if (!params.documentType) {
        throw new Error("documentType is required");
    }
    if (!params.documentNumber) {
        throw new Error("documentNumber is required");
    }
    params = {
        regularization: {
            document_number: params.documentNumber,
            document_type: params.documentType
        }
    }
    const {data} = await jwtAuthAxios.post(`/deliveries/${delivery_id}/regularization`, params);
    return data;
}

deliveryServices.updateContentReception = async (delivery_id, params) => {
    if (!params.documentType) {
        throw new Error("documentType is required");
    }
    params = {
        content_reception: {
            type_of_document: params.documentType
        }
    }
    const {data} = await jwtAuthAxios.post(`/deliveries/${delivery_id}/content_reception`, params);
    return data;
}

deliveryServices.updateRiskAcknowledgement = async (delivery_id, params) => {
    if (!params.documentType) {
        throw new Error("documentType is required");
    }
    params = {
        risk_acknowledgement: {
            type_of_document: params.documentType
        }
    }
    const {data} = await jwtAuthAxios.post(`/deliveries/${delivery_id}/risk_acknowledgement`, params);
    return data;
}

deliveryServices.sendRiskAcknowledgementFile = async (delivery_id, file, signed) => {
    const formData = new FormData();
    formData.append("risk_acknowledgement_file[input_file]", file);
    formData.append("risk_acknowledgement_file[signed]", signed);
  
    const { data } = await jwtAuthAxios.post(
      `/deliveries/${delivery_id}/risk_acknowledgement_file`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      }
    );
    return data;
};  

deliveryServices.sendContentReceptionFile = async (delivery_id, file, signed) => {
    const formData = new FormData();
    formData.append("content_reception_file[input_file]", file);
    formData.append("content_reception_file[signed]", signed);

    const { data } = await jwtAuthAxios.post(
        `/deliveries/${delivery_id}/content_reception_file`,
        formData,
        {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        }
    );
    return data;
};

// Hacer botoncito para llamar a este
deliveryServices.removeRegularization = async (delivery_id) => {
    const params = {
        regularization: {
            document_number: null,
            document_type: null
        }
    }
    const {data} = await jwtAuthAxios.post(`/deliveries/${delivery_id}/regularization`, params);
    return data;
}

export default deliveryServices;
